import React from 'react';
import { Row, Col, Table } from 'react-bootstrap';

const ManifestExpandedRow = ({ shipment }) => {
  if (!shipment) return null;

  return (
    <div className="p-3">
      <Row className="mb-3 g-3">
        <Col xs={12} className="fs-10">
          <div className="d-flex gap-2">
            <strong>Shipping Address</strong>
            <span>
              {shipment?.order?.shipping_address?.address_line_1},
              {shipment?.order?.shipping_address?.address_line_2},
              {shipment?.order?.shipping_address?.city} -{' '}
              {shipment?.order?.shipping_address?.pincode}
            </span>
          </div>
        </Col>

        <Col xs={6} className="fs-10">
          <div className="d-flex gap-2">
            <strong>No. of Products</strong>
            <span>{shipment?.invoice_product_total_quantity}</span>
          </div>
        </Col>

        <Col xs={6} className="fs-10">
          <div className="d-flex gap-2">
            <strong>Amount</strong>
            <span>{shipment?.total_gross_amount}</span>
          </div>
        </Col>

        <Col xs={6} className="fs-10">
          <div className="d-flex gap-2">
            <strong>Payment Method</strong>
            <span>{shipment?.order?.payment_type || '—'}</span>
          </div>
        </Col>

        <Col xs={6} className="fs-10">
          <div className="d-flex gap-2">
            <strong>Last Updated</strong>
            <span>
              {shipment?.modified
                ? new Date(shipment.modified).toLocaleDateString()
                : '—'}
            </span>
          </div>
        </Col>

        <Col xs={6} className="fs-10">
          <div className="d-flex gap-2">
            <strong>Package Status</strong>
            <span>{shipment?.shipment_status || '—'}</span>
          </div>
        </Col>
      </Row>

      {shipment?.product_summary?.length > 0 && (
        <div className="table-responsive">
          <Table size="sm" bordered className="mb-0">
            <thead className="bg-200">
              <tr>
                <th className="text-nowrap text-center fs-10">SKU</th>
                <th className="text-nowrap text-center fs-10">Channel SKU</th>
                <th className="text-nowrap text-center fs-10">Product Name</th>
                <th className="text-nowrap text-center fs-10">Qty</th>
              </tr>
            </thead>

            <tbody>
              {shipment?.product_summary?.map((product, index) => (
                <tr key={index}>
                  <td className="text-center fs-10">
                    {product.product_sku || '—'}
                  </td>
                  <td className="text-center fs-10">
                    {product.channel_product_sku || '—'}
                  </td>
                  <td className="text-center fs-10">
                    {product.product_name || '—'}
                  </td>
                  <td className="text-center fs-10">
                    {product.quantity || '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </div>
  );
};

export default ManifestExpandedRow;
